import { render } from "./deviceConfig.vue?vue&type=template&id=7c772de7&scoped=true"
import script from "./deviceConfig.vue?vue&type=script&lang=js"
export * from "./deviceConfig.vue?vue&type=script&lang=js"

import "./deviceConfig.vue?vue&type=style&index=0&id=7c772de7&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c772de7"]])

export default __exports__